import { useState } from "react";
import { Layout } from "@/components/layout/Layout";
import { RenderHistory } from "@/components/render/RenderHistory";
import { useRendersQuery } from "@/api/renders";
import type { RenderStatus } from "@/types/render";

export function RendersPage() {
  const [statusFilter, setStatusFilter] = useState<RenderStatus | undefined>();

  const { data, isLoading } = useRendersQuery({
    status: statusFilter,
    // No pagination UI yet — don't let rows fall off the default limit of 20.
    limit: 500,
  });

  return (
    <Layout>
      <div className="mx-auto max-w-6xl p-6">
        <div className="mb-6 flex items-center justify-between">
          <h1 className="text-2xl font-bold text-ink">
            Renders
          </h1>
          <select
            value={statusFilter ?? "all"}
            onChange={(e) => {
              const val = e.target.value;
              setStatusFilter(
                val === "all" ? undefined : (val as RenderStatus),
              );
            }}
            className="rounded-lg border border-line bg-surface px-3 py-1.5 text-sm text-ink focus:border-line-strong focus:outline-none"
          >
            <option value="all">All Status</option>
            <option value="queued">Queued</option>
            <option value="rendering">Rendering</option>
            <option value="complete">Complete</option>
            <option value="error">Error</option>
          </select>
        </div>

        {isLoading ? (
          <div className="flex h-32 items-center justify-center">
            <div className="h-6 w-6 animate-spin rounded-full border-2 border-line border-t-accent" />
          </div>
        ) : (
          <RenderHistory jobs={data ?? []} />
        )}
      </div>
    </Layout>
  );
}
